<template lang="pug">
.form-auth
    .form-auth__header
        .form-auth__title
            | Авторизация

    .form-auth__body
        SvInput(
            v-model="login"
            type="text"
            placeholder="Логин"
            :withIcon="false"
            color="graylight"
            label="Логин / эл.почта"
            autocomplete="username"
        )

        SvInput.form-auth__password(
            v-model="password"
            type="password"
            placeholder="Пароль"
            :withIcon="false"
            color="graylight"
            label="Пароль"
            autocomplete="current-password"
        )

        SvCheckbox.form-auth__checkbox(
            v-model="remember"
            label="Запомнить меня"
        )

        .form-auth__error(
            v-if="error"
        )
            | {{ error }}

        SvButton.form-auth__button(
            text="Войти"
            @click="auth"
        )
</template>

<script>
import SvInput from '@/components/uikit/SvInput.vue';
import SvCheckbox from '@/components/uikit/SvCheckbox.vue';
import SvButton from '@/components/uikit/SvButton.vue';

export default {
  name: 'FormAuth',

  data() {
    return {
      error: '',
      remember: false,
      login: '',
      password: ''
    };
  },

  methods: {
      async auth () {
          try {
              await this.$store.dispatch('user/login', {
                  email: this.login,
                  password: this.password,
                  remember: this.remember
              });
              this.$router.push({ name: 'home' });
          } catch (e) {
              this.error = 'Ошибка входа';
          }
      },
  },

  components: {
    SvInput,
    SvButton,
    SvCheckbox,
  },
};
</script>

<style lang="scss" scoped>
.form-auth {
    width: 390px;

    &__header {
        background-color: #F8F8FA;
        border-radius: 15px 15px 0px 0px;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__title {
        color: #404450;
        font-size: 22px;
        font-weight: bold;
    }

    &__body {
        padding: 30px 40px 40px 40px;
        background-color: #fff;
        border-radius: 0 0 15px 15px;
    }

    &__checkbox {
        margin-bottom: 40px;
    }

    &__error {
        text-align: center;
        margin-bottom: 10px;
        color: #D74848;
        font-size: 12px;
        font-weight: 500;
    }

    &__password,
    &__checkbox {
        margin-top: 20px;
    }
}
</style>
